<template>
  <div>
    <div class="flex justify-between">
      <span class="inline-block mb-2 rounded-md shadow-sm lg:hidden">
        <button
          id="sort-menu"
          type="button"
          class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
          aria-haspopup="true"
          aria-expanded="false"
          @click="toggleFilterVisibiliti()"
        >
          <svg
            class="w-5 h-5 mr-3 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            ></path>
          </svg>
          Filtri
          <!-- Heroicon name: chevron-down -->
          <svg
            class="ml-2.5 -mr-1.5 h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </span>
      <span class="flex inline-block mb-2 justify-items-center lg:hidden">
        <button
          class="inline-flex items-center justify-center"
          v-show="filters.date !== null || filters.order_number !== null"
          @click="resetFilters()"
        >
          <span class="text-sm font-medium">
            Elimina filtri
          </span>
          <svg
            class="w-8 h-8 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </button>
      </span>
    </div>
    <div
      class="grid hidden gap-4 mb-4 lg:grid"
      :class="
        $route.name == 'OrdersHistoryTable' ||
        $route.name == 'OrdersHistoryUmbrella' ||
        $route.name == 'OrdersHistoryRoomService'
          ? ' grid-cols-5 '
          : ' grid-cols-4 '
      "
      id="filterspanel"
    >
      <div class="w-full col-span-4 lg:col-span-1">
        <label
          for="date"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          <span v-if="selectedType == 'tavolo-hotel'">
            Data
          </span>
          <span v-else>
            Data di consegna
          </span>
        </label>
        <date-picker
          class="mt-1 "
          @change="changeFilter"
          format="DD/MM/YYYY"
          valueType="YYYY-MM-DD"
          v-model="filters.date"
        ></date-picker>
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="showStatus">
        <label
          for="state"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Stato ordine</label
        >
        <select
          v-model="filters.status"
          name="state"
          id="state"
          @change="changeFilter"
          class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
        >
          <option :value="defaultStatus"></option>
          <option
            v-for="status in statuses"
            v-bind:value="status.id"
            :key="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="showType">
        <label
          for="state"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Tipo di ordine</label
        >
        <select
          @change="changeFilter"
          v-model="filters.type"
          name="state"
          id="state"
          class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
        >
          <option :value="defaultType"></option>
          <option v-for="type in types" v-bind:value="type.id" :key="type.id">
            {{ type.name }}
          </option>
        </select>
      </div>

      <div class="w-full col-span-4 lg:col-span-1">
        <label
          for="orderby"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Ordina per</label
        >
        <select
          @change="changeFilter"
          v-model="filters.orderby"
          name="orderby"
          id="orderby"
          class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
        >
          <option
            v-for="item in orderBy"
            v-bind:value="item.value"
            :key="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="this.showTable">
        <label
          v-if="$route.name == 'OrdersHistoryTable'"
          for="table_name"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Tavolo</label
        >
        <label
          v-if="$route.name == 'OrdersHistoryUmbrella'"
          for="table_name"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Ombrellone</label
        >
        <input
          @change="changeFilter"
          v-model="filters.table_name"
          name="table_name"
          id="table_name"
          class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
        />
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="this.showRoom">
        <label
          for="table_name"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Camera</label
        >
        <input
          @change="changeFilter"
          v-model="filters.room"
          name="table_name"
          id="table_name"
          class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
        />
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="this.showMenuTypes">
        <label
          for="table_name"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Pasto</label
        >
        <select
          @change="changeFilter"
          v-model="filters.menuType"
          name="menuTypes"
          id="menuTypes"
          class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
        >
          <option :value="defaultMenuType"></option>

          <option
            v-for="item in menuTypes"
            v-bind:value="item.id"
            :key="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="w-full col-span-4 lg:col-span-1" v-if="showOrderNumber">
        <label
          for="order_number"
          class="block text-sm font-medium leading-5 text-gray-700"
          >Numero ordine</label
        >
        <input
          @change="changeFilter"
          v-model="filters.order_number"
          name="order_number"
          id="order_number"
          class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
        />
      </div>
    </div>

    <div
      style=" border-top-color: #c2c2c2;border-bottom-color: #c2c2c2; border-right-color: #c2c2c2; background-color: #f6f6f6"
      class="px-2 py-1 my-2 bg-white border border-l-4 border-indigo-600 rounded sm:pl-4 sm:pr-6 "
      v-if="reportHotel.summary && reportHotel.summary.length > 0"
    >
      <div
        class="space-y-3 border-gray-200 sm:flex sm:items-center sm:justify-between sm:space-x-4 sm:space-y-0"
      >
        <div class="flex flex-wrap items-baseline ">
          <h3
            class="text-lg font-medium leading-6 text-gray-900 cursor-pointer"
            @click="toggleReport"
          >
            Riepilogo ordini
            <span class="text-base text-indigo-700" v-show="!reportHotelOpen"
              >apri</span
            >
            <span class="text-base text-indigo-700" v-show="reportHotelOpen"
              >chiudi</span
            >
          </h3>
        </div>
        <div class="flex">
          <span class="rounded-md shadow-sm">
            <button
              @click="openModalReport()"
              type="button"
              class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50"
            >
              Stampa
            </button>
          </span>
        </div>
      </div>

      <div v-if="reportHotelOpen" class="space-y-4">
        <div v-for="menuType in reportHotel.summary" :key="menuType.slug">
          <span
            class="mr-2 text-base font-bold leading-5 tracking-wide text-gray-500"
            >{{ getmenuTypeName(menuType.slug) }}</span
          >
          <span v-if="menuType.rooms_note.length > 0">
            <span
              :title="'Camera ' + comment.room"
              class="mr-2"
              v-for="(comment, index) in menuType.rooms_note"
              :key="'comment-' + menuType.slug + '-' + index"
            >
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800 "
              >
                Camera {{ comment.room }}:
              </span>
              <span class="text-xs ">
                {{ comment.note }}
              </span>
            </span>
          </span>
          <div class="">
            <div
              class="mt-2 ml-4"
              v-for="category in Object.keys(menuType.categories)"
              :key="menuType.slug + '-' + category"
            >
              <span>» {{ category }}</span>
              <div
                class="p-2 mt-1 border border-gray-200 rounded-md"
                v-for="dish in menuType.categories[category]"
                :key="menuType.slug + '-' + category + '-' + dish.dish"
              >
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100"
                >
                  {{ dish.qty }}
                </span>
                {{ dish.name }}

                <div v-if="dish.comments.length > 0">
                  <span
                    class="mr-2 text-xs font-bold leading-5 tracking-wide text-gray-500 uppercase"
                    >Note</span
                  >
                  <span
                    :title="'Camera' + comment.room"
                    class="mr-2"
                    v-for="(comment, index) in dish.comments"
                    :key="'comment-' + dish.id + '-' + index"
                  >
                    <span
                      class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800 "
                    >
                      Camera {{ comment.room }}
                    </span>
                    <span class="text-xs">
                      {{ comment.comment }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white shadow sm:rounded-md">
      <ul class="divide-y-2 divide-gray-100">
        <li v-for="order in orders" :key="order.id">
          <div
            class="block p-4 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
          >
            <div class="grid grid-cols-12 gap-2">
              <!-- -->
              <div class="grid grid-cols-12 col-span-12 gap-2 lg:col-span-9">
                <div
                  v-if="
                    getOrderTypeSlug(order.order_type_id) == 'tavolo-hotel' ||
                      getOrderTypeSlug(order.order_type_id) == 'tavolo' ||
                      getOrderTypeSlug(order.order_type_id) == 'umbrella' ||
                      getOrderTypeSlug(order.order_type_id) == 'roomservice'
                  "
                  class="col-span-12 lg:col-span-6 sm:flex sm:items-center sm:justify-between"
                >
                  <div
                    v-if="
                      getOrderTypeSlug(order.order_type_id) == 'tavolo-hotel'
                    "
                    class="text-sm font-medium leading-5 "
                    :class="getColorOrderType(order.order_type_id)"
                  >
                    <span class="underline"
                      >{{ order.menu_type_name }} camera {{ order.room }}</span
                    >
                    <span class="text-xs font-normal leading-5 text-gray-500">
                      {{ getDDD(order.created_at) }}</span
                    >
                  </div>
                  <div
                    v-else-if="
                      getOrderTypeSlug(order.order_type_id) == 'roomservice'
                    "
                  >
                    <div
                      class="text-sm font-medium leading-5 "
                      :class="getColorOrderType(order.order_type_id)"
                    >
                      <span class="font-bold text-gray-700">
                        #{{ order.order_number }}
                      </span>
                      <span class="underline">
                        {{ getOrderType(order.order_type_id) }}:
                        {{ order.room }}</span
                      >
                      <span class="text-xs font-normal leading-5 text-gray-500">
                        {{ getDDD(order.created_at) }}</span
                      >
                    </div>
                    <div class="flex mt-2">
                      <div
                        class="flex items-center text-sm leading-5 text-gray-500"
                      >
                        <svg
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span>
                          Da consegnare:
                          <time class="font-medium">{{
                            getCreatedAt(order.order_date)
                          }}</time>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    class="text-sm font-medium leading-5 "
                    :class="getColorOrderType(order.order_type_id)"
                  >
                    <span class="font-bold text-gray-700">
                      #{{ order.order_number }}
                    </span>
                    <span class="underline">
                      {{ getOrderType(order.order_type_id) }}:
                      {{ order.table_name }}</span
                    >
                    <span class="text-xs font-normal leading-5 text-gray-500">
                      {{ getDDD(order.created_at) }}</span
                    >
                  </div>
                </div>

                <div
                  v-else
                  class="col-span-12 lg:col-span-6 sm:flex sm:items-center sm:justify-between"
                >
                  <div>
                    <div
                      class="text-sm font-medium leading-5 "
                      :class="getColorOrderType(order.order_type_id)"
                    >
                      <span class="font-bold text-gray-700"
                        >#{{ order.order_number }}
                      </span>
                      <span class="underline">{{
                        getOrderType(order.order_type_id)
                      }}</span>
                      <span class="text-xs font-normal leading-5 text-gray-500">
                        {{ getDDD(order.created_at) }}</span
                      >
                    </div>
                    <div class="flex mt-2">
                      <div
                        class="flex items-center text-sm leading-5 text-gray-500"
                      >
                        <svg
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <span>
                          Da consegnare:
                          <time class="font-medium">{{
                            getCreatedAt(order.order_date)
                          }}</time>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-span-6 lg:text-center lg:col-span-3"
                  v-if="getOrderTypeSlug(order.order_type_id) != 'tavolo-hotel'"
                >
                  <OrderPrice :order="order"></OrderPrice>
                </div>

                <div
                  class="col-span-6 text-right lg:text-center lg:col-span-3"
                  v-if="getOrderTypeSlug(order.order_type_id) != 'tavolo-hotel'"
                >
                  <Badge :badge="getOrderStatus(order.order_status_id)"></Badge>
                </div>

                <div
                  class="flex flex-wrap w-full col-span-12 mt-1 "
                  v-if="
                    getOrderTypeSlug(order.order_type_id) != 'tavolo-hotel' &&
                      getOrderTypeSlug(order.order_type_id) != 'roomservice'
                  "
                >
                  <span class="mr-3">
                    {{ order.name }} {{ order.surname }}
                  </span>

                  <div
                    class="flex items-center mr-3 text-sm leading-5 text-gray-500"
                    v-if="getOrderTypeSlug(order.order_type_id) == 'domicilio'"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="flex-shrink-0 w-5 h-5 mr-1 text-gray-400"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <a
                      target="_blank"
                      :href="
                        'https://www.google.com/maps/search/?api=1&query=' +
                          order.street +
                          ' ' +
                          order.house_number +
                          ' ' +
                          order.zip +
                          ' ' +
                          order.city
                      "
                      >{{ order.street }}, {{ order.house_number }}
                      {{ order.zip }} {{ order.city }}</a
                    >
                  </div>

                  <div
                    class="flex items-center mr-3 text-sm leading-5 text-gray-500"
                    v-if="
                      getOrderTypeSlug(order.order_type_id) != 'tavolo' &&
                        getOrderTypeSlug(order.order_type_id) != 'umbrella'
                    "
                  >
                    <svg
                      class="flex-shrink-0 w-5 h-5 mr-1 text-gray-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                      />
                      <path
                        d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                      />
                    </svg>
                    <a :href="'mailto:' + order.email">{{ order.email }}</a>
                  </div>

                  <div
                    class="flex items-center mr-3 text-sm leading-5 text-gray-500"
                    v-if="
                      getOrderTypeSlug(order.order_type_id) != 'tavolo' &&
                        getOrderTypeSlug(order.order_type_id) != 'umbrella'
                    "
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="flex-shrink-0 w-5 h-5 mr-1 text-gray-400"
                    >
                      <path
                        d="M17.924 2.617a.997.997 0 00-.215-.322l-.004-.004A.997.997 0 0017 2h-4a1 1 0 100 2h1.586l-3.293 3.293a1 1 0 001.414 1.414L16 5.414V7a1 1 0 102 0V3a.997.997 0 00-.076-.383z"
                      ></path>
                      <path
                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                      ></path>
                    </svg>
                    <a :href="'tel:' + order.phone">{{ order.phone }}</a>
                  </div>
                </div>
                <div
                  v-if="order.delivery_note != null"
                  class="flex items-start w-full col-span-12 mt-1"
                >
                  <span
                    class="inline-flex items-center flex-shrink-0 px-2 text-xs font-medium leading-5 text-blue-500 bg-blue-100 rounded-full"
                  >
                    Note consegna:
                  </span>
                  <span class="ml-1 text-sm">
                    {{ order.delivery_note }}
                  </span>
                </div>
                <div
                  v-if="order.note != null && order.note != ''"
                  class="flex items-start w-full col-span-12 mt-1 "
                >
                  <span
                    class="inline-flex items-center flex-shrink-0 px-2 text-xs font-medium leading-5 text-gray-800 bg-green-100 rounded-full"
                  >
                    Note ordine:
                  </span>
                  <span class="ml-1 text-sm">
                    {{ order.note }}
                  </span>
                </div>
              </div>

              <!-- -->

              <div class="col-span-12 lg:col-span-3">
                <div class="flex items-center justify-end flex-1">
                  <button
                    @click="toggleDetail(order)"
                    v-show="!order.showDetail"
                    class="inline-flex justify-center px-4 py-2 mr-1 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="w-5 h-5 eye"
                    >
                      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path>
                      <path
                        fill-rule="evenodd"
                        d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>

                  <button
                    @click="toggleDetail(order)"
                    v-show="order.showDetail"
                    class="inline-flex justify-center px-4 py-2 mr-1 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="w-5 h-5 eye-off"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                        clip-rule="evenodd"
                      ></path>
                      <path
                        d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
                      ></path>
                    </svg>
                  </button>

                  <OrderDropDown
                    v-on:childToParent="onChildClick"
                    v-on:changeStatus="onChangeStatus"
                    :order="order"
                    :typeOption="orderDropDownType"
                  />
                </div>
              </div>
            </div>

            <!-- v-if="order.showDetail" -->

            <div
              class="pt-3 pb-4 mt-4 border-t border-dashed"
              v-if="order.showDetail"
            >
              <span class="text-sm font-medium ">Dettaglio ordine:</span>
              <ul class="px-2 mt-2 space-y-3">
                <li
                  v-for="dish in order.order_detail"
                  :key="order.id + '_' + dish.dish_id"
                >
                  <div class="flex items-center">
                    <span class="text-sm">
                      <div>
                        <div class="flex items-center">
                          <span
                            class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100"
                          >
                            {{ dish.qty }}
                          </span>

                          <span class="mx-2">{{ dish.name }}</span>

                          <div v-if="dish.comment">
                            <span
                              class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800"
                            >
                              {{ dish.comment }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <Pagination
      v-on:paginate="onChangePaginate"
      :pagination="pagination"
      :offset="3"
    />

    <ModalOrder
      v-if="modalOrder.show"
      :locationId="this.id"
      :event="modalOrder.event"
      :formErrors="modalOrder.formErrors"
      :eventclose="modalOrder.eventclose"
      :initialOrder="modalOrder.order"
      :types="types"
      :statuses="statuses"
      :menuTypes="menuTypes"
    ></ModalOrder>

    <ModalPrintReport
      v-if="modalprint.show"
      :eventclose="modalprint.eventclose"
      :menuTypes="menuTypes"
      :date="filters.date"
      :filters="filters"
      :locationid="id"
    />
    <!--:reportHotel="reportHotel"-->

    <modal
      v-show="modal.show"
      :event="modal.event"
      :icon="modal.icon"
      :buttonText="modal.buttonText"
      :buttonClass="modal.buttonClass"
      :eventclose="modal.eventclose"
      :title="modal.title"
      :description="modal.description"
    ></modal>

    <div
      class="text-yellow-400 text-green-500 text-teal-500 text-blue-500 text-purple-500 text-pink-600 bg-pink-100"
    ></div>
  </div>
</template>

<script>
import Order from "./../apis/Order";
import Pagination from "./../components/Pagination";
import ModalOrder from "./../components/ModalOrder";
import ModalPrintReport from "./../components/ModalPrintReport";
import Badge from "./../components/Badge";
import DatePicker from "vue2-datepicker";
import OrderPrice from "./../components/OrderPrice";
import OrderDropDown from "./../components/OrderDropDown";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";
import { format, formatDistanceToNow } from "date-fns";
import locale from "date-fns/locale/it";
import Modal from "../components/Modal";

export default {
  props: {
    avaibleOrderBy: {
      type: Array,
      required: false,
    },
    defaultOrderBy: {
      type: String,
      required: false,
    },
    menuTypesToInclude: {
      type: Array,
      required: false,
    },
    typesToInclude: {
      type: Array,
      required: false,
    },
    statusToInclude: {
      type: Array,
      required: false,
    },
    selectedStatus: {
      type: String,
      required: false,
    },
    selectedType: {
      type: String,
      required: false,
    },
    selectedMenuType: {
      type: String,
      required: false,
    },
    showStatus: {
      type: Boolean,
      required: false,
    },
    showOrderNumber: {
      type: Boolean,
      required: false,
    },
    showType: {
      type: Boolean,
      required: false,
    },
    initDate: {
      type: Boolean,
      required: false,
    },
    showTable: {
      type: Boolean,
      required: false,
    },
    showRoom: {
      type: Boolean,
      required: false,
    },
    showMenuTypes: {
      type: Boolean,
      required: false,
    },
    orderDropDownType: {
      type: String,
      required: false,
      default: "type1",
    },
  },
  components: {
    Pagination,
    DatePicker,
    ModalOrder,
    Badge,
    OrderPrice,
    OrderDropDown,
    Modal,
    ModalPrintReport,
  },
  data() {
    return {
      ids: [],
      defaultType: null,
      defaultStatus: null,
      defaultMenuType: null,
      id: this.$route.params.id,
      modalprint: {
        show: false,
        eventclose: "",
        menuTypes: [],
      },
      modalOrder: {
        show: false,
        order: {},
        event: "",
        eventclose: "",
        formErrors: {},
      },
      modal: {
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
      orders: {},
      reportHotel: {},
      reportHotelOpen: false,
      statuses: null,
      types: null,
      menuTypes: null,
      filters: {
        type: null,
        menuType: null,
        date: null,
        status: null,
        orderby: null,
        page: null,
        table_name: null,
        room: null,
        order_number: null,
      },
      pagination: {
        current_page: 1,
        from: null,
        last_page: 1,
        per_page: 5,
        to: null,
        total: null,
      },
      orderBy: [
        {
          label: "Ora di consegna (decrescente)",
          value: "order_date|desc",
          default: true,
        },
        { label: "Ora di consegna (crescente)", value: "order_date|asc" },
        { label: "Ora di ricezione (decrescente)", value: "created_at|desc" },
        { label: "Ora di ricezione (crescente)", value: "created_at|asc" },
        { label: "Camera (crescente)", value: "room|asc" },
        { label: "Camera (decrescente)", value: "room|desc" },
      ],
    };
  },
  mounted() {
    if (this.$route.query.order_number != undefined) {
      this.filters.order_number = this.$route.query.order_number;
    }

    //this.loadOrder();
    if (this.initDate) {
      this.filters.date = format(new Date(), "yyyy-MM-dd");
    }

    if (this.avaibleOrderBy) {
      this.orderBy = this.orderBy.filter((order) =>
        this.avaibleOrderBy.includes(order.value)
      );
    }

    if (this.defaultOrderBy) {
      let def = this.orderBy.find((x) => x.value == this.defaultOrderBy);
      if (def) {
        this.filters.orderby = def.value;
      }
    }

    Order.getStatusesTypes()
      .then((response) => {
        if (this.statusToInclude != undefined) {
          this.statuses = response.data.statuses.filter((status) =>
            this.statusToInclude.includes(status.abbrevation)
          );
          this.defaultStatus = this.statuses.map((x) => x.id).join(",");
          this.filters.status = this.defaultStatus;
        } else {
          this.statuses = response.data.statuses;
        }

        if (this.selectedStatus != undefined) {
          this.filters.status = this.statuses.find(
            (stats) => stats.abbrevation === this.selectedStatus
          ).id;
        }

        if (this.typesToInclude != undefined) {
          this.types = response.data.types.filter((type) =>
            this.typesToInclude.includes(type.slug)
          );
          this.defaultType = this.types.map((x) => x.id).join(",");
          this.filters.type = this.defaultType;
        } else {
          this.types = response.data.types;
        }

        if (this.selectedType != undefined) {
          this.filters.type = this.types.find(
            (type) => type.slug === this.selectedType
          ).id;
        }

        if (this.menuTypesToInclude != undefined) {
          this.menuTypes = response.data.menuTypes.filter((type) =>
            this.menuTypesToInclude.includes(type.slug)
          );
          this.defaultMenuType = this.menuTypes.map((x) => x.id).join(",");
          this.filters.menuType = this.defaultMenuType;
        } else {
          this.menuTypes = response.data.menuTypes;
        }

        if (this.selectedMenuType != undefined) {
          this.filters.menuTypes = this.menuTypes.find(
            (type) => type.slug === this.selectedMenuType
          ).id;
        }
      })
      .then(() => {
        this.loadOrder();

        this.loadReport();
      });
  },
  computed: {
    /*
      calcola(){
        if (this.typesToInclude != undefined &&  this.types != null){
          return this.types.map(x => x.id);
        }

        return null;
      }
      */
  },
  methods: {
    toggleFilterVisibiliti() {
      let div = document.getElementById("filterspanel");
      div.classList.toggle("hidden");
    },
    resetFilters() {
      this.filters.date = null;
      this.filters.page = null;
      this.filters.order_number = null;

      this.loadOrder();
    },
    openModalReport() {
      this.$root.$on("clickCloseModalPrint", () => {
        this.modalprint.show = false;
        this.$root.$off("clickCloseModalPrint");
      });

      this.modalprint.eventclose = "clickCloseModalPrint";
      this.modalprint.show = true;
    },

    openOrderModal() {
      if (this.selectedType != undefined) {
        let order_type_id = this.types.find(
          (type) => type.slug === this.selectedType
        ).id;

        let baseObj = {
          action: "create_order",
          location_id: 999999999,
          order_type_id,
          menu_type_id: null,
          order_status_id: null,
          table_name: null,
          room: null,
          name: null,
          surname: null,
          house_number: null,
          city: null,
          zip: null,
          street: null,
          phone: null,
          email: null,
          note: null,
          shipping_fee: 0,
          delivery_note: null,
          menu_type_name: null,
          order_detail: [],
        };

        this.modalOrder.order = baseObj;
        this.modalOrder.show = true;
        this.modalOrder.event = "clickSaveModalOrderNew";
        this.modalOrder.eventclose = "clickCloseModalOrderNew";

        this.$root.$on("clickCloseModalOrderNew", () => {
          this.modalOrder.show = false;
          this.$root.$off("clickSaveModalOrderNew");
          this.$root.$off("clickCloseModalOrderNew");
        });

        this.$root.$on("clickSaveModalOrderNew", (neworder) => {
          this.$store.dispatch("updateSpinner", true);
          this.modalOrder.formErrors = {};

          Order.create(this.id, neworder)
            .then((response) => {
              this.$store.dispatch("updateSpinner", false);
              this.$store.dispatch("addNotification", {
                id: Math.floor(Math.random() * 100000),
                title: "Ordine aggiornato",
                description: "L'ordine è stato aggiornato con successo",
              });
              this.modalOrder.show = false;

              this.loadOrder();
              console.log(response);
              console.log(this.orders);

              this.$root.$off("clickSaveModalOrderNew");
            })
            .catch((error) => {
              this.$store.dispatch("updateSpinner", false);
              if (error.response.status === 422) {
                this.modalOrder.formErrors = error.response.data.errors;
                this.$store.dispatch("addNotification", {
                  id: Math.floor(Math.random() * 100000),
                  title: "Correggi gli errori",
                  description: "",
                  succes: false,
                });
              } else {
                this.$store.dispatch("addNotification", {
                  id: Math.floor(Math.random() * 100000),
                  title: "Errore",
                  description: error,
                  succes: false,
                });
              }
            });
        });
      }
    },

    toggleReport() {
      this.reportHotelOpen = !this.reportHotelOpen;
    },

    getmenuTypeName(slug) {
      switch (slug) {
        case "breakfast":
          return "Colazione";
        case "lunch":
          return "Pranzo";
        case "dinner":
          return "Cena";
      }
      return slug;
    },

    /*
    getComments(rooms, comments){
      let roomsSplit = rooms.split(',');
      let commentsSplit = comments.split(',');

      let result = [];

      for (let i=0; i<roomsSplit.length; i++){
        result.push({
          room: roomsSplit[i],
          comment: commentsSplit[i],
        });
      }

      return result;
    },
    */

    onChangePaginate(pagenumber) {
      this.filters.page = pagenumber;
      this.loadOrder();
    },

    toggleDetail(order) {
      //console.log(order.showDetail);
      if (order.showDetail == undefined) {
        this.$set(order, "showDetail", true);
      } else {
        order.showDetail = !order.showDetail;
      }
      //console.log(order);
    },

    onChildClick(order) {
      this.ids.push(order.id);
      this.editPoupOrder(order);
    },

    onChangeStatus(order, slug) {
      this.ids.push(order.id);
      if (slug == "rejected") {
        this.modal.event = "clickOrderStatus" + order.id + slug;
        this.modal.eventclose = "clickCloseOrderStatus" + order.id + slug;
        this.modal.title = "Rifiutare l'ordine?";
        this.modal.description =
          "Al cliente verrà inviata una email per informarlo che non è possibile accettare il suo ordine";
        this.modal.icon = "alert";
        this.modal.buttonText = "Rifiuta ordine";
        this.modal.buttonClass =
          "bg-red-600 hover:bg-red-500  focus:border-red-700 focus:shadow-outline-red";
        this.modal.show = true;

        if (
          this.getOrderTypeSlug(order.order_type_id) == "tavolo" ||
          this.getOrderTypeSlug(order.order_type_id) == "umbrella" ||
          this.getOrderTypeSlug(order.order_type_id) == "roomservice"
        ) {
          this.modal.description =
            "Sei sicuro di voler rifiutare l'ordine? Il cliente NON verrà informato";
        }

        this.$root.$on("clickOrderStatus" + order.id + slug, () => {
          this.updateStatus(order.id, slug);
          this.$root.$off("clickOrderStatus" + order.id + slug);
        });

        this.$root.$on("clickCloseOrderStatus" + order.id + slug, () => {
          this.modal.show = false;
        });
      } else if (slug == "delete") {
        this.modal.event = "clickOrderStatus" + order.id + slug;
        this.modal.eventclose = "clickCloseOrderStatus" + order.id + slug;
        this.modal.title = "Eliminare l'ordine?";
        this.modal.description = "L'ordine verrà cancellato definitivamente";
        this.modal.icon = "alert";
        this.modal.buttonText = "Elimina ordine";
        this.modal.buttonClass =
          "bg-red-600 hover:bg-red-500  focus:border-red-700 focus:shadow-outline-red";
        this.modal.show = true;

        this.$root.$on("clickOrderStatus" + order.id + slug, () => {
          this.updateStatus(order.id, slug);
          this.$root.$off("clickOrderStatus" + order.id + slug);
        });

        this.$root.$on("clickCloseOrderStatus" + order.id + slug, () => {
          this.modal.show = false;
        });
      } else if (slug == "approved") {
        this.modal.event = "clickOrderStatus" + order.id + slug;
        this.modal.eventclose = "clickCloseOrderStatus" + order.id + slug;
        this.modal.title = "Approvare l'ordine?";
        this.modal.description =
          "Al cliente verrà inviata una email di conferma dell'ordine";
        this.modal.icon = "party";
        this.modal.buttonText = "Approva ordine";
        this.modal.buttonClass =
          "bg-green-400 hover:bg-green-500  focus:border-green-400 focus:shadow-outline-green";
        this.modal.show = true;

        if (
          this.getOrderTypeSlug(order.order_type_id) == "tavolo" ||
          this.getOrderTypeSlug(order.order_type_id) == "umbrella" ||
          this.getOrderTypeSlug(order.order_type_id) == "roomservice"
        ) {
          this.modal.description = "Sei sicuro di voler approvare l'ordine?";
        }

        this.$root.$on("clickOrderStatus" + order.id + slug, () => {
          this.updateStatus(order.id, slug);
          console.log("off" + order.id + slug);
          this.$root.$off("clickOrderStatus" + order.id + slug);
        });

        this.$root.$on("clickCloseOrderStatus" + order.id + slug, () => {
          this.modal.show = false;
        });
      } else if (slug == "waiting") {
        this.modal.event = "clickOrderStatus" + order.id + slug;
        this.modal.eventclose = "clickCloseOrderStatus" + order.id + slug;
        this.modal.title = "Modificare lo stato dell'ordine?";
        this.modal.description =
          "L'ordine verrà spostato nella sezione 'Ordini da approvare' e il cliente verra avvertito tramite email";
        this.modal.icon = "alert";
        this.modal.buttonText = "Modifica stato";
        this.modal.buttonClass =
          "bg-red-600 hover:bg-red-500  focus:border-red-700 focus:shadow-outline-red";
        this.modal.show = true;

        if (
          this.getOrderTypeSlug(order.order_type_id) == "tavolo" ||
          this.getOrderTypeSlug(order.order_type_id) == "umbrella" ||
          this.getOrderTypeSlug(order.order_type_id) == "roomservice"
        ) {
          this.modal.description =
            "L'ordine verrà spostato nella sezione 'Ordini da approvare'";
        }

        this.$root.$on("clickOrderStatus" + order.id + slug, () => {
          this.updateStatus(order.id, slug);
          this.$root.$off("clickOrderStatus" + order.id + slug);
        });

        this.$root.$on("clickCloseOrderStatus" + order.id + slug, () => {
          this.modal.show = false;
        });
      } else if (slug == "completed" || slug == "in-progress") {
        this.updateStatus(order.id, slug);
      }
    },

    updateStatus(orderid, slug) {
      this.$store.dispatch("updateSpinner", true);
      Order.updateStatus(this.id, orderid, { status: slug })
        .then((response) => {
          this.$store.dispatch("updateSpinner", false);
          this.$store.dispatch("addNotification", {
            id: Math.floor(Math.random() * 100000),
            title: "Stato aggiornato",
            description: "Lo stato dell'ordine è stato aggiornato con successo",
          });
          this.modal.show = false;

          let index = this.orders.findIndex((x) => x.id === orderid);
          if (index != undefined) {
            if (
              slug == "delete" ||
              slug == "waiting" ||
              (slug == "rejected" && this.$route.name == "OrdersHistory") ||
              (slug == "approved" && this.$route.name == "OrdersHistory")
            ) {
              this.filters.page = 1;
              this.loadOrder();
            } else {
              //console.log(response.data);
              //console.log(index);
              //console.log(this.orders[0]);
              //this.orders[index] = response.data;
              this.orders[index].order_status_id =
                response.data.order_status_id;
            }
          }
        })
        .catch((error) => {
          this.$store.dispatch("updateSpinner", false);
          this.$store.dispatch("addNotification", {
            id: Math.floor(Math.random() * 100000),
            title: "Errore",
            description: error,
            succes: false,
          });
        });
    },

    getDDD(date) {
      //console.log(date);
      return formatDistanceToNow(new Date(date), {
        locale: locale,
        addSuffix: true,
      });
      //return formatDistanceToNow(new Date(), { locale: locale, addSuffix: true})
    },

    chiudi(dish) {
      console.log("o", dish);
      dish.showDrop = false;
    },

    editPoupOrder(order) {
      this.modalOrder.order = order;
      this.modalOrder.show = true;
      this.modalOrder.event = "clickSaveModalOrder" + order.id;
      this.modalOrder.eventclose = "clickCloseModalOrder" + order.id;

      this.$root.$on("clickCloseModalOrder" + order.id, () => {
        this.modalOrder.show = false;
        this.$root.$off("clickSaveModalOrder" + order.id);
        this.$root.$off("clickCloseModalOrder" + order.id);
      });

      this.$root.$on("clickSaveModalOrder" + order.id, (orderupdate) => {
        this.$store.dispatch("updateSpinner", true);
        this.modalOrder.formErrors = {};

        Order.update(this.id, orderupdate.id, orderupdate)
          .then((response) => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {
              id: Math.floor(Math.random() * 100000),
              title: "Ordine aggiornato",
              description: "L'ordine è stato aggiornato con successo",
            });
            this.modalOrder.show = false;

            let index = this.orders.findIndex((x) => x.id === order.id);
            if (index != undefined) {
              //this.orders[index] = response.data;
              //this.orders[index] = JSON.parse(JSON.stringify(response.data));

              this.orders.splice(index, 1, response.data);

              //this.$set(this.orders[index], 'order_detail', response.data.order_detail)
              console.log(this.orders);

              //this.$set(order, 'showDetail', true);
            }

            this.$root.$off("clickSaveModalOrder" + order.id);
            this.$root.$off("clickCloseModalOrder" + order.id);
          })
          .catch((error) => {
            this.$store.dispatch("updateSpinner", false);
            if (error.response.status === 422) {
              this.modalOrder.formErrors = error.response.data.errors;
              this.$store.dispatch("addNotification", {
                id: Math.floor(Math.random() * 100000),
                title: "Correggi gli errori",
                description: "",
                succes: false,
              });
            } else {
              this.$store.dispatch("addNotification", {
                id: Math.floor(Math.random() * 100000),
                title: "Errore",
                description: error,
                succes: false,
              });
            }
          });
      });
    },

    changeFilter() {
      this.filters.page = 1;
      this.loadOrder();

      this.loadReport();
    },

    getCreatedAt(date) {
      return format(new Date(date), "dd/MM/yyyy HH:mm");
    },

    getOrderStatus(statusid) {
      let s = this.statuses.filter((status) => status.id == statusid);
      if (s.length > 0) {
        return {
          text: s[0].name,
          textColor: s[0].color,
          bgColor: s[0].secondary_color,
        };
      }
      return {};
    },

    getOrderStatusOld(statusid) {
      let s = this.statuses.filter((status) => status.id == statusid);
      if (s.length > 0) {
        return s[0].name;
      }
      return "";
    },

    getOrderType(typeid) {
      let s = this.types.filter((type) => type.id == typeid);
      if (s.length > 0) {
        return s[0].name;
      }
      return "";
    },

    getColorOrderType(typeid) {
      let s = this.types.filter((type) => type.id == typeid);
      if (s.length > 0) {
        return s[0].color;
      }
      return "";
    },

    getOrderTypeSlug(typeid) {
      let s = this.types.filter((type) => type.id == typeid);
      if (s.length > 0) {
        return s[0].slug;
      }
      return "";
    },

    loadReport() {
      if (this.$route.name == "OrdersHistoryHotel") {
        Order.getReportHotel(this.id, this.filters)
          .then((response) => {
            this.reportHotel = response.data;
          })
          .catch(() => {
            console.log("Error loadReport");
          });
      }
    },

    loadOrder() {
      this.$store.dispatch("updateSpinner", true);
      Order.getOrders(this.id, this.filters)
        .then((response) => {
          this.orders = response.data.data;

          this.pagination.current_page = response.data.current_page;
          this.pagination.from = response.data.from;
          this.pagination.last_page = response.data.last_page;
          this.pagination.per_page = response.data.per_page;
          this.pagination.to = response.data.to;
          this.pagination.total = response.data.total;

          this.$store.dispatch("updateSpinner", false);
        })
        .catch(() => {
          this.$store.dispatch("updateSpinner", false);
        });
    },
  },
  beforeDestroy() {
    this.$root.$off("clickCloseModalPrint");
    this.$root.$off("clickSaveModalOrderNew");
    this.$root.$off("clickCloseModalOrderNew");

    for (let i = 0; i < this.ids.length; i++) {
      this.$root.$off("clickOrderStatus" + this.ids[i]);
      this.$root.$off("clickCloseOrderStatus" + this.ids[i]);
      this.$root.$off("clickSaveModalOrder" + this.ids[i]);
      this.$root.$off("clickCloseModalOrder" + this.ids[i]);
    }
  },
};
</script>

<style scoped>
.mx-datepicker {
  width: 100%;
}
</style>
